import React, { useState, useMemo, useCallback } from 'react';
import { observer } from 'mobx-react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { ButtonsList } from '@ann/web-components';
import {
  PageContainer,
  ContentContainer,
  TabSwitcherContainer,
} from './Activity.styled';
import CommunicationsTab from './pages/CommunicationsTab';
import NotesTab from './pages/NotesTab';

const TABS = {
  COMMUNICATIONS: 'communications',
  NOTES: 'notes',
};

const Activity = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine active tab from URL
  const activeTab = useMemo(() => {
    if (location.pathname.includes('/notes')) {
      return TABS.NOTES;
    }
    return TABS.COMMUNICATIONS;
  }, [location.pathname]);

  // Handle tab change
  const handleTabChange = useCallback((tabId) => {
    navigate(tabId, { replace: true });
  }, [navigate]);

  // Tab configuration
  const tabItems = useMemo(
    () => [
      {
        id: TABS.COMMUNICATIONS,
        label: 'Communications',
      },
      {
        id: TABS.NOTES,
        label: 'Notes',
      },
    ],
    []
  );

  const buttonsListItems = useMemo(
    () =>
      tabItems.map(({ id, label }) => ({
        label,
        onClick: () => handleTabChange(id),
        selected: activeTab === id,
      })),
    [tabItems, handleTabChange, activeTab]
  );

  return (
    <PageContainer>
      <ContentContainer>
        <TabSwitcherContainer>
          <ButtonsList items={buttonsListItems} size="medium" />
        </TabSwitcherContainer>
      </ContentContainer>
      <Routes>
        <Route path="/" element={<Navigate to="communications" replace />} />
        <Route path="communications" element={<CommunicationsTab />} />
        <Route path="notes" element={<NotesTab />} />
      </Routes>
    </PageContainer>
  );
});

export default Activity;
